<template>
    <div class="modal fade" id="unitModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-backdrop="static" style="margin-top: 10%">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="actionSiteType === 'CREATE'">{{ $t("site_newSiteType") }}</h5>
                    <h5 class="modal-title" v-else-if="actionSiteType === 'UPDATE'">{{ $t("site_editSiteType") }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onCancelButton()"></button>
                </div>
                <div class="modal-body">
                    <form class="kt-form kt-form--label-right" data-cy="NewSiteForm" autocomplete="off">
                        <div class="kt-portlet__body">
                            <div class="kt-section">
                                <div class="kt-section__body">
                                    <div class="form-group row validated">
                                        <div class="col-lg-12">
                                            <div class="input-group" style="display: flex; align-items: baseline; justify-content: space-between;">
                                                <div class="mr-2">
                                                    <span>{{ $t("site_siteName") }}</span>
                                                </div>
                                                <div style="width: 90%;">
                                                    <input id="newSiteNameInput" type="text" maxlength="80" class="form-control" :placeholder=" (actionSiteType === 'CREATE' || actionSiteType === 'UPDATE') && $t('site_inputInfoTypeName')" v-model="siteTypeNameInputVal" />
                                                    <div v-if="!$v.siteTypeNameInputVal.required" class="invalid-feedback">
                                                        {{ $t("error_fieldIsRequired") }}
                                                    </div>
                                                    <div v-else-if="!$v.siteTypeNameInputVal.minLen" class="invalid-feedback">
                                                        {{ $t("error_minLengthMsg", [$v.siteTypeNameInputVal.$params.minLen.min]) }}
                                                    </div>
                                                    <div v-else-if="!this.isNameUnique" class="invalid-feedback">
                                                        {{ $t("error_siteTypeNameIsNotUnique") }}
                                                    </div>
                                                    <span class="form-text text-muted">{{ $t("site_detailInfoSiteName") }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer" v-if="actionSiteType === 'CREATE'">
                    <button id="unitModalCancelButton" @click="onCancelButton()" type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("common_cancel") }}</button>
                    <button id="unitModalAddButton" @click="onAddSiteType()" type="button" data-dismiss="modal" class="btn btn-brand" :disabled="this.$v.$invalid || !isNameUnique">{{ $t("common_add") }}</button>
                </div>
                <div class="modal-footer" v-else-if="actionSiteType === 'UPDATE'">
                    <button id="unitModalCancelButton" @click="onCancelButton()" type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("common_cancel") }}</button>
                    <button id="unitModalAddButton" @click="onEditSiteType()" type="button" data-dismiss="modal" class="btn btn-brand" :disabled="this.$v.$invalid || !isNameUnique || !isFormDataChanged">{{ $t("common_save") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, minLength} from "vuelidate/lib/validators";
import i18n from "../../i18n";

export default {
    data() {
        return {
            siteTypeNameInputVal: "",
            oldSiteTypeNameInputVal: "",
            isNameUnique: true,
            isFormDataChanged: false
        };
    },
    created: function() {
        console.log("Component(UnitModal)::created() - called");
    },
    mounted: function() {
        console.log("Component(UnitModal)::mounted() - called");
        $("#unitModal").keypress(event => {
            const keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode == "13") {
                switch(this.actionSiteType) {
                    case "CREATE":
                        event.preventDefault();
                        if(!this.$v.$invalid && this.isNameUnique) {
                            this.onAddSiteType();
                        }
                        break;
                    case "UPDATE":
                        event.preventDefault();
                        if(!this.$v.$invalid && this.isNameUnique && this.isFormDataChanged) {
                            this.onEditSiteType();
                        }
                        break;
                }
            }
        });
    },
    destroyed: function() {
        console.log("Component(UnitModal)::destroyed() - called");
    },
    validations: {
        // -- validations -- List of controls to apply to validate a form.
        // --
        siteTypeNameInputVal: {
            required,
            minLen: minLength(2)
        },
    },
    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        // --
        siteTypeNameInputVal: function(name) {
            console.log("Component(UnitModal)::watch(siteTypeNameInputVal) called");

            this.isNameUnique = true;
            if (name) {
                if (this.siteType) {
                    for (let type of this.siteTypes) {
                        if (type.isDefault && type.id !== this.siteType.id && i18n.t(type.name) === name) {
                            return this.isNameUnique = false;
                        }
                        else if (type.id !== this.siteType.id && type.name === name) {
                            return this.isNameUnique = false;
                        }
                    } 
                } else {
                    for (let type of this.siteTypes) {
                        if (type.isDefault && i18n.t(type.name) === name) {
                            return this.isNameUnique = false;
                        }
                        else if (type.name === name) {
                            return this.isNameUnique = false;
                        }
                    } 
                }
            }
            this.onChangeForm();
        },

        siteType: function(siteType) {
            console.log("Component(UnitModal)::watch(siteType) called");
            this.siteTypeNameInputVal = siteType && siteType.name || "";
            this.oldSiteTypeNameInputVal = siteType && siteType.name || "";
        }
    },
    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --
        ...mapGetters(["actionSiteType", "siteType", "siteTypes"])
    },
    methods: {
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        ...mapActions(["hideSiteTypeModal", "createNewSiteType", "deleteSiteTypeById", "editSiteTypeById", "resetSiteTypeModal"]),
        onCancelButton() {
            this.siteTypeNameInputVal = "";
            setTimeout(() => {
                this.resetSiteTypeModal();
            }, 50);
        },

        onAddSiteType() {
            console.log("Component(UnitModal)::onAddSiteType() - called ");
            this.hideSiteTypeModal();

            const siteTypeId = new Date().getTime();
            const params = {
                id: siteTypeId,
                isDefault: false,
                name: this.siteTypeNameInputVal
            };
            this.createNewSiteType({siteId: this.$route.params.siteId, ...params});

            setTimeout(() => {
                this.resetSiteTypeModal();
            }, 50);

        },

        onEditSiteType() {
            console.log("Component(UnitModal)::onEditSiteType() - called ");
            this.hideSiteTypeModal();

            const params = {
                id: this.siteType.id,
                name: this.siteTypeNameInputVal
            };
            this.editSiteTypeById({siteId: this.$route.params.siteId, ...params});

            setTimeout(() => {
                this.resetSiteTypeModal();
            }, 50);
        },
        onChangeForm() {
            if (this.siteTypeNameInputVal === this.oldSiteTypeNameInputVal) {
                return this.isFormDataChanged = false;
            }
            return this.isFormDataChanged = true;
        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
    }
};
</script>

<style scoped></style>
